<template>
  <div class="course-create-wrap">
    <a-form :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">资讯信息</div>
        <div class="info-content" style="padding-top:25px;padding-bottom:30px;">
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="资讯标题"
              >
                <a-input
                  placeholder="请输入资讯标题"
                  v-decorator="[
                    'title',
                    {rules: [{ required: true, message: '请输入资讯标题' }]},
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="资讯类型"
              >
                <a-radio-group
                  name="radioGroup"
                  @change="typeChange"
                  v-decorator="[
                    'type',
                    {rules: [{ required: false, message: '请输入资讯类型' }]}
                  ]">
                  <a-radio value="1">
                    图片
                  </a-radio>
                  <a-radio value="2">
                    视频
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="type==1">
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="资讯图片   ">
                <div class="">
                  <div class="clearfix">
                    <div class="">
                      <div
                        v-for="(item,i) in attachmentListImg"
                        :key="i"
                        style="float:left;width:120px;height:120px;display:inline-block;overflow:hidden;margin-right:10px;background-color: #fafafa;
    border: 1px dashed #d9d9d9;">
                        <img :src="item.obsObjectUrl" alt="" style="width:120px;">
                      </div>
                    </div>
                    <a-upload
                      v-decorator="[
                        'attachmentListImg',
                        {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: false, message: '请上传图片' }]},
                      ]"
                      listType="picture-card"
                      class="face-picture"
                      :showUploadList="false"
                      :action="uploadAction"
                      :headers="headers"
                      :beforeUpload="imgBeforeUpload"
                      @change="courseCoverChange"
                    >
                      <div v-if="attachmentListImg.length<3">
                        <a-icon type="plus" />
                      </div>
                    </a-upload>

                    <!-- <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                      <img alt="example" style="width: 100%" :src="previewImage" />
                    </a-modal> -->
                  </div>
                </div>
                <div class="img-tip">
                  请上传710*260像素或同比例的图片，小于5M!
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="type==2">
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 8 }"
                label="资讯视频   "
              >
                <div class>
                  <div class="clearfix">
                    <a-upload
                      v-decorator="[
                        'attachmentListVideo',
                        {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: false, message: '请上传视频' }]},
                      ]"
                      listType="picture-card"
                      class="face-picture"
                      :showUploadList="false"
                      :action="uploadAction"
                      :headers="headers"
                      :beforeUpload="videoBeforeUpload"
                      @change="videoFullChange"
                    >
                      <span v-if="attachmentListVideo.length!=0&&!videoFullloading">已上传</span>
                      <div v-else>
                        <a-icon :type="videoFullloading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text" v-show="videoFullloading">正在上传...</div>
                      </div>
                    </a-upload>
                  </div>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="资讯正文   ">
                <j-editor
                  v-decorator="[
                    'content',
                    {rules: [{ required: true, message: '请输入资讯标题' }]},
                  ]"
                  triggerChange></j-editor>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="信息来源   ">
                <div class="">
                  <div class="clearfix">
                    <div class="">
                      <a-input
                        placeholder="请输入信息来源"
                        style="margin-bottom:15px"
                        v-decorator="[
                          'publishName',
                          {rules: [{ required: false, message: '请输入资讯标题' }]},
                        ]"
                      />
                    </div>
                    <div class="">
                      <a-upload
                        v-decorator="[
                          'publishAvatar',
                          {valuePropName: 'file',getValueFromEvent: normFile1,rules: [{ required: false, message: '请上传图片' }]},
                        ]"
                        listType="picture-card"
                        class="face-picture"
                        :showUploadList="false"
                        :action="uploadAction"
                        :headers="headers"
                        :beforeUpload="imgBeforeUpload"
                        @change="publishAvatarChange"
                      >
                        <img v-if="publishAvatar" :src="publishAvatar" style="width:100%;"/>
                        <div v-else>
                          <a-icon :type="publishAvatarloading ? 'loading' : 'plus'" />
                          <div class="ant-upload-text"></div>
                        </div>
                      </a-upload>
                      上传信息源图像<br>
                      上传200*200或同比例的图片，小于5M
                    </div>
                  </div>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="资讯标签"
              >
                <a-select
                  v-decorator="[
                    'tag',
                    {rules: [{ required: true, message: '请输入资讯标签' }]},
                  ]"
                  mode="tags"
                  style="width: 100%"
                  placeholder="请在这里输入标签，按回车添加多个">
                </a-select>
                <!-- <a-input
                  placeholder="请输入资讯标题"
                  v-decorator="[
                    'title',
                    {rules: [{ required: true, message: '请输入资讯标题' }]},
                  ]"
                /> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 4 }"
                label="显示栏目   ">
                <j-dict-select-tag
                  v-decorator="['informationType', {rules: [{ required: false, message: '请选择显示栏目' }]}, ,{}]"
                  placeholder="显示栏目"
                  dictCode="information_type"
                  :triggerChange="true"/>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card
        :bordered="false"
        style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);"
      >
        <div class="a-row">
          <a-button
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
            type="primary"
            @click="videoCreateOk()"
          >保存</a-button>
        </div>
      </a-card>
    </a-form>
  </div>
</template>

<script>

  import Vue from 'vue'
  import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
  import { httpAction, getAction } from '@/api/manage'

  import pick from 'lodash.pick'

  import _ from 'lodash'
  // import moment from 'moment'

  export default {
    name: 'CreateInfo',
    components: { },
    mixins: [],
    data() {
      return {
        downloadButton: false,
        downloadData: {
          url: '',
          icon: window._CONFIG['domianURLHttp'] + '/smlogo.jpg'
        },
        downloadFullData: {
          url: '',
          icon: window._CONFIG['domianURLHttp'] + '/smlogo.jpg'
        },
        // config: {
        //     value: 'https://baidu.com',
        //     imagePath: 'http://www.elinkx.com.cn:3000/img/logo.bb4c241e.png',
        //     filter: 'color'
        // },
        courseId: '', // 编辑的时候的课程id
        chName: '', // 课程名称
        chProfile: '', // 课程简介
        chOrder: '',
        attachmentListImg: [],
        attachmentListVideo: [],
        publishAvatar: '',
        publishAvatarloading: false,

        courseTeachers: [
          {
              // id:"",
              idSrc: '',
              teacherDesc: '',
              teacherName: '',
              headFile: ''
          }
        ], // 课程讲师
        faceloading: false,
        videoloading: false,
        videoFullloading: false,
        videoFull: {},
        isFrom: '',
        form: this.$form.createForm(this),
        loading: false,
        imageUrl: '',
        previewVisible: false,
        previewImage: '',
        fileList: [
        //   {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        // }
        ],
        url: {
          fileUpload: window._CONFIG['domianURL'] + '/sys/common/upload',
          add: '/cms/elinkxCmsInformation/add',
          edit: '/cms/elinkxCmsInformation/edit',
          queryById: '/cms/elinkxCmsInformation/queryById'
        },
        type: 1,
        id: ''
      }
    },

    methods: {
      normFile(e) {
        console.log('Upload event:', e)
        if (Array.isArray(e)) {
          return e
        }
        return e && e.file && e.file.response && e.file.response.result
      },
      normFile1(e) {
        console.log('Upload event:', e)
        if (Array.isArray(e)) {
          return e
        }
        return e && e.file && e.file.response && e.file.response.result && e.file.response.result.obsObjectUrl
      },
      // 类型变更
      typeChange (e) {
        this.type = e.target.value
      },
      videoChange (info, j, k) {
        if (info.file.status === 'uploading') {
          this.videoloading = true
          return
        }

        if (info.file.status === 'done') {
          this.video = info.file.response.result
          this.downloadData.url = window._CONFIG['domianURLHttp'] + '/mediaPlay?type=1&id=' + this.video.id

          this.videoloading = false
        }
      },
      videoFullChange (info, j, k) {
        if (info.file.status === 'uploading') {
          this.videoFullloading = true
          return
        }

        if (info.file.status === 'done') {
          this.attachmentListVideo = [info.file.response.result]
          this.videoFullloading = false
        }
      },
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
      },
      courseCoverChange(info, i, j) {
        if (info.file.status === 'uploading') {
          this.faceloading = true
          return
        }
        if (info.file.status === 'done') {
          this.attachmentListImg.push(info.file.response.result)
        }
      },
      publishAvatarChange(info, i, j) {
        if (info.file.status === 'uploading') {
          this.publishAvatarloading = true
          return
        }
        if (info.file.status === 'done') {
          this.publishAvatar = info.file.response.result.obsObjectUrl
          this.publishAvatarloading = false
        }
      },

      // 图片上传前校验
      imgBeforeUpload (file) {
        const isJPG = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.name)

        if (!isJPG) {
          this.$message.error('只能上传图片!')
        }

        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('图片大小要小于5MB!')
        }
        return isJPG && isLt5M
      },

      // 音频上传前校验
      videoBeforeUpload (file) {
        const isJPG = /\.(mp4)$/.test(file.name)

        if (!isJPG) {
          this.$message.error('只能上传mp4视频!')
        }

        const isLt10M = file.size / 1024 / 1024 < 500
        if (!isLt10M) {
          this.$message.error('图片大小要小于500MB!')
        }
        return isJPG && isLt10M
      },

      // 保存
      videoCreateOk() {
        const that = this
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''

            let formData = {}
            if (this.type === '1') {
              formData = { ...values, attachmentList: this.attachmentListImg }
            } else {
              formData = { ...values, attachmentList: this.attachmentListVideo }
            }
            formData.tag = formData.tag ? formData.tag.join(',') : ''
            delete formData.attachmentListImg
            delete formData.attachmentListVideo

            if (!this.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
              formData['id'] = this.id
            }

            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
                this.$router.push({ path: '/views/information/ElinkxCmsInformationList' })
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }
        })
      }

    },

    created () {
      const token = Vue.ls.get(ACCESS_TOKEN)
      let tenantid = Vue.ls.get(TENANT_ID)

      this.headers = { 'X-Access-Token': token, 'tenant_id': tenantid }

      this.id = this.$route.query.id
      // this.chapterId = this.$route.query.chapterId
      // this.isFrom = this.$route.query.isFrom
      // this.id = this.$route.query.id

      if (!_.isEmpty(this.id)) {
        getAction(this.url.queryById, { id: this.id }, 'get').then((res) => {
          if (res.success) {
            // that.$message.success(res.message)
            // that.$emit('ok')
            let resultData = res.result
            resultData.tag = resultData.tag ? resultData.tag.split(',') : []
            this.type = resultData.type
            this.publishAvatar = resultData.publishAvatar
            if (resultData.type === '1') {
              this.attachmentListImg = resultData.attachmentList || []
            } else {
              this.attachmentListVideo = resultData.attachmentList || []
            }
            this.$nextTick(() => {
              this.form.setFieldsValue(pick(resultData, 'publishAvatar', 'title', 'tag', 'publishName', 'content', 'type', 'informationType'))
            })
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
          this.confirmLoading = false
        })

        // queryChDetail({ id: this.id }).then((res) => {
        //   if (res.code == 0) {
        //     console.log(res)
        //     let resultData = res.result
        //     resultData['courseStartDate'] = moment(resultData['courseStartDate'], 'YYYY-MM-DD')

        //     this.$nextTick(() => {
        //       this.form.setFieldsValue(pick(resultData, 'chName', 'chProfile', 'chOrder', 'video', 'videoFull'))
        //     })

        //     this.video = resultData.video ? resultData.video : { obsObjectUrl: '' }
        //     this.videoFull = resultData.videoFull ? resultData.videoFull : { obsObjectUrl: '' }

        //     this.downloadData.url = window._CONFIG['domianURLHttp'] + '/mediaPlay?type=1&id=' + this.video.id
        //     this.downloadFullData.url = window._CONFIG['domianURLHttp'] + '/mediaPlay?type=1&id=' + this.videoFull.id
        //   } else {
        //     this.$message.warning(res.message)
        //   }
        // }).finally(() => {
        // })
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.type = '1';
        this.form.setFieldsValue({ 'type': '1' })
      })
    },
    computed: {
      uploadAction: function () {
        return this.url.fileUpload
      }
    }
  }
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
.course-create-wrap {
  .info-title {
    border-bottom: 1px solid #e7ecef;
    line-height: 50px;
    height: 50px;
    padding-left: 25px;
  }

  .info-content {
    .img-tip {
      color: #999999;
      font-size: 12px;
    }
  }
}
</style>
